import { useEffect, useMemo, useState } from 'react';

/**
 * Observe if element is currently in the viewPort, similar to useOnVisible, but it will monitor viewport.
 * @param ref React Mutable Ref Object, ref to element being observed
 * @returns boolean
 */
const useOnViewport = (ref: React.MutableRefObject<HTMLElement>, threshold = 0): boolean => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;

  const [isIntersecting, setIsIntersecting] = useState(false);

  const options = {
    rootMargin: '0px',
    threshold,
  };

  const observer = useMemo(
    () => new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting), options),
    []
  );

  useEffect(() => {
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, observer]);

  return isIntersecting;
};

export default useOnViewport;
